// import React, { useState, useEffect } from "react";
// import "./styles.css";
// import { IoIosClose } from "react-icons/io";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from 'react-redux';
// import { removeFromCart, setCart, setTotalItems, setTotalPrice } from '../../store/cartSlice';
// import { getWithTokenAPI, postWithTokenAPI } from "../../util/Api";
// import { useSelector } from "react-redux";

// const ShoppingCartPopup = ({ isOpen, onClose }) => {
//   const navigate = useNavigate();
//   const token = useSelector((state) => state.auth?.auth?.access_token);
//   const userId = useSelector((state) => state.auth?.auth?._id);
//   const dispatch = useDispatch();
//   const [cartSuccessMessage, setCartSuccessMessage] = useState('');
//   const [removingFromCart, setRemovingFromCart] = useState(false);
//   const [error, setError] = useState(null);
//   const [isLoginPopupOpen, setLoginPopupOpen] = useState(false);
//   const [cartItems, setCartItems] = useState([]);
//   const totalPrice = useSelector((state) => state.cart.totalPrice);
//   const totals = useSelector((state) => state.cart.totalItems);

//   // Block body scroll when cart is open
//   useEffect(() => {
//     const originalStyle = window.getComputedStyle(document.body).overflow;
    
//     if (isOpen) {
//       document.body.style.overflow = 'hidden';
//       document.body.style.position = 'fixed';
//       document.body.style.top = `-${window.scrollY}px`;
//       document.body.style.width = '100%';
//     }

//     return () => {
//       document.body.style.overflow = originalStyle;
//       document.body.style.position = '';
//       const scrollY = document.body.style.top;
//       document.body.style.top = '';
//       window.scrollTo(0, parseInt(scrollY || '0') * -1);
//     };
//   }, [isOpen]);

//   // Fetch cart from API
//   useEffect(() => {
//     const fetchCart = async () => {
//       if (!token || !isOpen) return;
//       try {
//         const res = await getWithTokenAPI(token, `/cart/find-all?user_id=${userId}`, {});
//         if (res?.data?.Cart?.length > 0) {
//           const cartData = res.data.Cart[0];
//           // const totalCount = res.data.total_count; // We will calculate this from items array

//           const items = cartData.cart.map((item) => {
//             const price = parseFloat(item.discount_price || item.product_id.price);
//             return {
//               id: item._id,
//               productId: item.product_id._id,
//               name: item.product_id.name,
//               quantity: item.quantity,
//               price: price,
//               image: item.product_id.product_image[0],
//               total: price * item.quantity
//             };
//           });
//           const calculatedTotalItems = items.reduce((sum, item) => sum + item.quantity, 0);

//           setCartItems(items);
//           dispatch(setCart(items));
//           dispatch(setTotalItems(calculatedTotalItems)); // Use calculated total items
//           dispatch(setTotalPrice(items.reduce((sum, item) => sum + item.total, 0)));
//         } else {
//           setCartItems([]);
//           dispatch(setCart([]));
//           dispatch(setTotalPrice(0));
//           dispatch(setTotalItems(0));
//         }
//       } catch (error) {
//         console.error("Error fetching cart:", error);
//       }
//     };

//     fetchCart();
//   }, [token, isOpen, dispatch, userId]);

//   const handleRemoveCartItem = async (cartItem) => {
//     if (!token) {
//       navigate('/login');
//       return;
//     }
//     if (!cartItem?.productId || removingFromCart) return;
//     setRemovingFromCart(true);
//     setError(null);

//     try {
//       const payload = {
//         cart: [
//           {
//             product_id: cartItem.productId,
//             quantity: 0
//           }
//         ]
//       };

//       const response = await postWithTokenAPI(token, '/cart/add', payload);

//       if (response?.statusCode === 200 || response?.status === 200) {
//         const updatedItems = cartItems.filter(item => item.productId !== cartItem.productId);
//         setCartItems(updatedItems);
//         dispatch(setCart(updatedItems));
//         dispatch(setTotalItems(updatedItems.reduce((sum, item) => sum + item.quantity, 0)));
//         dispatch(setTotalPrice(updatedItems.reduce((sum, item) => sum + item.total, 0)));

//         setCartSuccessMessage('Item removed successfully!');
//         setTimeout(() => setCartSuccessMessage(''), 3000);

//         // Re-fetch cart from API to ensure full synchronization
//         const res = await getWithTokenAPI(token, `/cart/find-all?user_id=${userId}`);
//         if (res?.data?.Cart?.length > 0) {
//           const cartData = res.data.Cart[0];
//           const items = cartData.cart.map((item) => {
//             const price = parseFloat(item.discount_price || item.product_id.price);
//             return {
//               id: item._id,
//               productId: item.product_id._id,
//               name: item.product_id.name,
//               quantity: item.quantity,
//               price: price,
//               image: item.product_id.product_image[0],
//               total: price * item.quantity
//             };
//           });
//           const calculatedTotalItemsAfterRemove = items.reduce((sum, item) => sum + item.quantity, 0);

//           setCartItems(items);
//           dispatch(setCart(items));
//           dispatch(setTotalItems(calculatedTotalItemsAfterRemove)); // Use calculated total items from API response
//           dispatch(setTotalPrice(items.reduce((sum, item) => sum + item.total, 0)));
//         } else {
//           setCartItems([]);
//           dispatch(setCart([]));
//           dispatch(setTotalPrice(0));
//           dispatch(setTotalItems(0));
//         }
//       } else {
//         setError(response?.message || 'Failed to remove item');
//       }
//     } catch (err) {
//       console.error('Error removing item:', err);
//       setError('Something went wrong. Please try again.');
//     } finally {
//       setRemovingFromCart(false);
//     }
//   };

//   return (
//     <>
//       {isOpen && (
//         <div className="shopping-cart-overlay" onClick={onClose}></div>
//       )}

//       <div className={`shopping-cart-popup ${isOpen ? "active" : ""}`}>
//         <div className="cart-header">
//           <h2 className="cart-title">Shopping Cart ({totals})</h2>
//           <button className="close-button" onClick={onClose}>
//             <IoIosClose size={24} className="close-icon" />
//           </button>
//         </div>

//         {cartItems.length === 0 ? (
//           <div className="empty-cart-message">
//             <div className="empty-cart-icon">
//               <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//                 <circle cx="10" cy="20.5" r="1" />
//                 <circle cx="18" cy="20.5" r="1" />
//                 <path d="M2.5 2.5h3l2.7 12.4a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6l1.6-8.4H7.1" />
//               </svg>
//             </div>
//             <h3>Your cart is empty</h3>
//             <p>Looks like you haven't added anything to your cart yet</p>
//             <button 
//               className="continue-shopping-button"
//               onClick={() => {
//                 onClose();
//                 navigate("/shop");
//               }}
//             >
//               Continue Shopping
//             </button>
//           </div>
//         ) : (
//           <>
//             <div className="cart-items">
//               {cartItems.map((item, index) => (
//                 <div className="cart-item" key={index}>
//                   <div
//                     className="item-image"
//                     style={{ backgroundImage: `url(${item.image})` }}
//                   ></div>
//                   <div className="item-details">
//                     <h3 className="item-name">{item.name}</h3>
//                     <div className="item-price">
//                       <span className="weight">{item.quantity} pcs</span>
//                       <span className="my">x</span>
//                       <span className="calculate">KSh {item.price.toFixed(2)}</span>
//                       <span className="item-total">= KSh {(item.price * item.quantity).toFixed(2)}</span>
//                     </div>
//                   </div>
//                   <button
//                     onClick={() => handleRemoveCartItem(item)}
//                     className="remove-item"
//                     disabled={removingFromCart}
//                   >
//                     {removingFromCart ? '...' : '×'}
//                   </button>
//                 </div>
//               ))}
//             </div>

//             <div className="cart-summary">
//               <div className="subtotal">
//                 <span className="totalvalues">{totals} Products</span>
//                 <span className="totalvalue">KSh {totalPrice.toFixed(2)}</span>
//               </div>

//               <div className="cart-buttons">
//                 <button
//                   className="continue-shopping-button"
//                   onClick={() => navigate("/Shopping_Cart")}
//                 >
//                   Go to Cart
//                 </button>
//               </div>
//             </div>
//           </>
//         )}
//       </div>
//     </>
//   );
// };

// export default ShoppingCartPopup;


import React, { useState, useEffect } from "react";
import "./styles.css";
import { IoIosClose } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { removeFromCart, setCart, setTotalItems, setTotalPrice } from '../../store/cartSlice';
import { getWithTokenAPI, postWithTokenAPI } from "../../util/Api"; // Adjust path as needed
import { useSelector } from "react-redux"; // Assuming token is in Redux

const ShoppingCartPopup = ({ isOpen, onClose, apiEndpoint = '/cart/find-all' }) => {
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth?.auth?.access_token);
  //  const userId = useSelector((state) => state.auth?.auth?._id);
  const dispatch = useDispatch();
  const [cartSuccessMessage, setCartSuccessMessage] = useState('');
  const [removingFromCart, setRemovingFromCart] = useState(false);
  const [error, setError] = useState(null);
  const [isLoginPopupOpen, setLoginPopupOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const totalPrice = useSelector((state) => state.cart.totalPrice);
  const totals = useSelector((state) => state.cart.totalItems);
    const userId = useSelector((state) => state.auth?.auth?._id);
    // const totals = useSelector((state) => state.cart.totalItems);


  // Fetch cart from API
  useEffect(() => {
    const fetchCart = async () => {
      if (!token || !isOpen) return;
      const res = await getWithTokenAPI(token, `/cart/find-all?user_id=${userId}`);
      if (res?.data?.Cart?.length > 0) {
        const cartData = res.data.Cart[0];
        const totalCount = res.data.Cart[0].cart.length;
        
        // Map items with proper price handling
        const items = cartData.cart.map((item) => {
          const price = parseFloat(item.discount_price || item.product_id.price);
          return {
            id: item._id,
            productId: item.product_id._id,
            name: item.product_id.name,
            quantity: item.quantity,
            price: price,
            image: item.product_id.product_image[0],
            total: price * item.quantity
          };
        });
        
        // Update both local state and Redux store
        setCartItems(items);
        dispatch(setCart(items));
        dispatch(setTotalItems(totalCount));
        
        // Update total price in Redux
        const calculatedTotal = items.reduce((sum, item) => sum + item.total, 0);
        dispatch(setTotalPrice(calculatedTotal));
      } else {
        setCartItems([]);
        dispatch(setCart([]));
        dispatch(setTotalPrice(0));
        dispatch(setTotalItems(0));
      }
    };

    fetchCart();
  }, [token, isOpen, dispatch]);

useEffect(() => {
          
  if (isOpen) {
     
    document.body.classList.add('no-scroll');
         
  } else {
          
    document.body.classList.remove('no-scroll');
        
  }
      
  return () => document.body.classList.remove('no-scroll');
 
}, [isOpen]);

  const handleRemoveCartItem = async (cartItem) => {
    if (!token) {
      navigate('/login');
      return;
    }
    if (!cartItem?.productId || removingFromCart) return;
    setRemovingFromCart(true);
    setError(null);

    try {
      const payload = {
        cart: [
          {
            product_id: cartItem.productId,
            quantity: 0
          }
        ]
      };

      const response = await postWithTokenAPI(token, '/cart/add', payload);

      if (response?.statusCode === 200 || response?.status === 200) {
        // Update local state immediately
          dispatch(removeFromCart(cartItem.id));
      
        
   


        setCartSuccessMessage('Item removed successfully!');
        setTimeout(() => setCartSuccessMessage(''), 3000);

        // Refresh cart data from API
        const res = await getWithTokenAPI(token, `/cart/find-all?user_id=${userId}`);
        if (res?.data?.Cart?.length > 0) {
          const cartData = res.data.Cart[0];
          const items = cartData.cart.map((item) => {
            const price = parseFloat(item.discount_price || item.product_id.price);
            return {
              id: item._id,
              productId: item.product_id._id,
              name: item.product_id.name,
              quantity: item.quantity,
              price: price,
              image: item.product_id.product_image[0],
              total: price * item.quantity
            };
          });
          
          setCartItems(items);
          dispatch(setCart(items));
          
      
        } else {
          setCartItems([]);
          dispatch(setCart([]));
          dispatch(setTotalPrice(0));
          dispatch(setTotalItems(0));
        }
      } else {
        setError(response?.message || 'Failed to remove item');
      }
    } catch (err) {
      console.error('Error removing item:', err);
      setError('Something went wrong. Please try again.');
    } finally {
      setRemovingFromCart(false);
    }
  };

  const totalItems = cartItems.reduce((acc, item) => acc + item.quantity, 0);
  

  return (
    <>
      {isOpen && (
        <div className="shopping-cart-overlay" onClick={onClose}></div>
      )}

      <div className={`shopping-cart-popup ${isOpen ? "active" : ""}`}>
        <div className="cart-header">
          <h2 className="cart-title">Shopping Cart ({totals})</h2>
          <button className="close-button" onClick={onClose}>
            <IoIosClose size={24} className="close-icon" />
          </button>
        </div>

        <div className="cart-items">
          {cartItems.length > 0 ? (
            cartItems.map((item, index) => (
              <div className="cart-item" key={index}>
                <div
                  className="item-image"
                  style={{ backgroundImage: `url(${item.image})` }}
                ></div>
                <div className="item-details">
                  <h3 className="item-name">{item.name}</h3>
                  <div className="item-price">
                    <span className="weight">{item.quantity} pcs</span>
                    <span className="my">x</span>
                    <span className="calculate">KSh {item.price.toFixed(2)}</span>
                    <span className="item-total">= KSh {(item.price * item.quantity).toFixed(2)}</span>
                  </div>
                </div>
                <button
                  onClick={() => handleRemoveCartItem(item)}
                  className="remove-item"
                  disabled={removingFromCart}
                >
                  {removingFromCart ? '...' : '×'}
                </button>
              </div>
            ))
          ) : (
            <p className="empty-cart">Your cart is empty.</p>
          )}
        </div>

        <div className="cart-summary">
          <div className="subtotal">
            <span className="totalvalues">{totals} Products</span>
            <span className="totalvalue">KSh {totalPrice.toFixed(2)}</span>
          </div>

          <div className="cart-buttons">
            {/* <button
              className="checkout-button"
              onClick={() => navigate("/checkout")}
              disabled={cartItems.length === 0}
            >
              Checkout
            </button> */}
            <button
              className="continue-shopping-button"
              onClick={() => navigate("/Shopping_Cart")}
              disabled={cartItems.length === 0}
            >
              Go to Cart
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShoppingCartPopup;
